// extracted by mini-css-extract-plugin
export var Footer = "styles-module--Footer--fa986";
export var GoogleApp = "styles-module--GoogleApp--693ce";
export var IosApp = "styles-module--IosApp--53c5d";
export var Links = "styles-module--Links--b1d54";
export var Social = "styles-module--Social--a845a";
export var Terms = "styles-module--Terms--d72c1";
export var cookiePreferencesBtn = "styles-module--cookiePreferencesBtn--6aa81";
export var facebook = "styles-module--facebook--3c28a";
export var instagram = "styles-module--instagram--ac1f1";
export var linkedin = "styles-module--linkedin--5faaa";
export var x = "styles-module--x--ec491";
export var youtube = "styles-module--youtube--e90ef";